import React from 'react';
import {Box, createStyles, SvgIcon, withStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core';
import PropTypes from 'prop-types';
import {ReactComponent as InfoIcon} from 'assets/icons/section/miscelaneous/info.svg';
import {InferPropTypes} from 'commons/types/Types';
import {EfeTooltip} from 'components';
import * as colors from 'assets/theme/colors';

const HelpIconStyles = createStyles((theme: Theme) => ({
    titleIcon: {
        whiteSpace: 'pre-line',
        ...theme.typography.caption,
        color: colors.secondary.A01,
        backgroundColor: theme.palette.common.white,
    },
    tooltip: {
        verticalAlign: 'middle',
    },
    helpIcon: {
        verticalAlign: 'middle',
        fontSize: 16,
        lineHeight: theme.spacing(6),
        cursor: 'pointer'
    },
}));

function EfeHelpIcon(
    props: InferPropTypes<typeof EfeHelpIcon.propTypes, typeof HelpIconStyles>
) {
    const {title, classes} = props;
    const areaRef = React.useRef<SVGSVGElement>(null);

    return (
        <EfeTooltip title={<Box>{title}</Box>} arrow>
            <SvgIcon
                height={16}
                width={16}
                color='primary'
                className={classes.helpIcon}>
                <InfoIcon ref={areaRef} />
            </SvgIcon>
        </EfeTooltip>
    );
}

EfeHelpIcon.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node]),
};

export default withStyles(HelpIconStyles)(EfeHelpIcon);
